













import {Component, Vue} from 'vue-property-decorator';
import {i18n} from "../plugin/i18n";
import ButtonNextPage from '../components/ButtonNextPage.vue';
import LittleArticleCarrousel from '../components/LittleArticleCarrousel.vue';
import {Meta} from '../decorators/decorators';

@Component({
	components: {LittleArticleCarrousel, ButtonNextPage},
})

export default class TrendingNow extends Vue {
	articles: any[] = i18n.t('TrendingNow.articles') as any; // recupération des articles dans le fichiers de trad
	title: String = i18n.t('TrendingNow.title') as string;
	subTitle: String = i18n.t('TrendingNow.subTitle') as string;

	@Meta
	myMetaConfig() {
		return {
			title: i18n.t('TrendingNow.title')
		}
	}
}
